/* eslint-disable jsx-a11y/iframe-has-title */
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { useTranslation } from 'react-i18next';

function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <section className="contact-page">
        <HeroPages name={t('contact.title')} />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2>{t('contact.needInfo')}</h2>
              <p>{t('contact.description')}</p>
              <a href="/">
                <i className="fa-solid fa-phone"></i>{t('contact.contactInfo.phone')}
              </a>
              <a href="/">
                <i className="fa-solid fa-envelope"></i>
                {t('contact.contactInfo.email')}
              </a>
              <a href="/">
                <i className="fa-solid fa-location-dot"></i>{t('contact.contactInfo.address')}
              </a>
            </div>
            <div className="contact-div__form">
              <form>
                <label>
                  {t('contact.form.fullName')} <b>{t('common.required')}</b>
                </label>
                <input type="text" placeholder={t('contact.form.fullNamePlaceholder')}></input>

                <label>
                  {t('contact.form.email')} <b>{t('common.required')}</b>
                </label>
                <input type="email" placeholder={t('contact.form.emailPlaceholder')}></input>

                <label>
                  {t('contact.form.message')} <b>{t('common.required')}</b>
                </label>
                <textarea placeholder={t('contact.form.messagePlaceholder')}></textarea>

                <button type="submit">
                  <i className="fa-solid fa-envelope-open-text"></i>&nbsp; {t('contact.form.sendButton')}
                </button>
              </form>
            </div>
          </div>
          <div className="mekan-360">
            <iframe
              src="https://mekan360.com/sanaltur/axima_tanitim/index.html"
              width="100%"
              height="500"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
